export default __webpack_public_path__ + "static/media/bj.c1bc198c.svg";